window.colorMap = {};



    
    
    window.colorMap["multi"] = "multi-icon.jpg";

    
    
    window.colorMap["hot pink"] = "#e86288";

    
    
    window.colorMap["weathered teak"] = "#9f9283";

    
    
    window.colorMap["smoked pearl"] = "#6a6c6e";

    
    
    window.colorMap["star white"] = "#ecece7";

    
    
    window.colorMap["anthracite"] = "#3d3f43";

    
    
    window.colorMap["violet tulip"] = "#9c90c4";

    
    
    window.colorMap["barrier reef"] = "#0088a5";

    
    
    window.colorMap["peacoat"] = "#3f3f50";

    
    
    window.colorMap["peacock"] = "#3f3f50";

    
    
    window.colorMap["rifle green"] = "#515848";

    
    
    window.colorMap["doeskin"] = "#bdad9a";

    
    
    window.colorMap["estate blue"] = "#3a4462";

    
    
    window.colorMap["glacier gray"] = "#c5c9ca";

    
    
    window.colorMap["shadow purple"] = "#573e54";

    
    
    window.colorMap["gibraltar sea"] = "#30475e";

    
    
    window.colorMap["seal brown"] = "#4b4140";

    
    
    window.colorMap["tannin"] = "#a68b6f";

    
    
    window.colorMap["frost gray"] = "#848587";

    
    
    window.colorMap["ebony"] = "#494d53";

    
    
    window.colorMap["lucent white"] = "#f3f4f5";

    
    
    window.colorMap["pink dogwood"] = "#f5d3d4";

    
    
    window.colorMap["botanical garden"] = "#30524e";

    
    
    window.colorMap["elephant gray"] = "#a9b1b3";

    
    
    window.colorMap["dark sapphire"] = "#3a3d49";

    
    
    window.colorMap["silver sconce"] = "#9e9ea3";

    
    
    window.colorMap["montana grape"] = "#6e6276";

    
    
    window.colorMap["zinfandel"] = "#663f45";

    
    
    window.colorMap["winsome orchid"] = "#d4b9cb";

    
    
    window.colorMap["kentucky blue"] = "#a0b0d1";

    
    
    window.colorMap["limestone"] = "#9c9f9c";

    
    
    window.colorMap["plumeria"] = "#f891a3";

    
    
    window.colorMap["very grape"] = "#b994b2";

    
    
    window.colorMap["cocoa crème"] = "#8b7360";

    
    
    window.colorMap["lava falls"] = "#9f383a";

    
    
    window.colorMap["winter moss"] = "#60614c";

    
    
    window.colorMap["ethereal blue"] = "#61a9d2";

    
    
    window.colorMap["burnt coral"] = "#e9897e";

    
    
    window.colorMap["cactus flower"] = "#ac4977";

    
    
    window.colorMap["teal green"] = "#276a6c";

    
    
    window.colorMap["antique green"] = "#3b6d69";

    
    
    window.colorMap["spa retreat"] = "#b6e7ec";

    
    
    window.colorMap["fiery red"] = "#d2393e ";

    
    
    window.colorMap["blue wing teal"] = "#384b60";

    
    
    window.colorMap["pastel blue"] = "#bdd6d9";

    
    
    window.colorMap["plum kitten"] = "#615e60";

    
    
    window.colorMap["hawthorn rose"] = "#d189af";

    
    
    window.colorMap["twill"] = "#a89f84";

    
    
    window.colorMap["ashleigh blue"] = "#6f8aad";

    
    
    window.colorMap["rose dawn"] = "#c2877b";

    
    
    window.colorMap["stone blue"] = "#809ca7";

    
    
    window.colorMap["harbor mist"] = "#b0b2b5";

    
    
    window.colorMap["deep sea"] = "#53817b";

    
    
    window.colorMap["bijou blue"] = " #4d6080";

    
    
    window.colorMap["pirate black"] = "#373838";

    
    
    window.colorMap["castlerock"] = "#5f5e62";

    
    
    window.colorMap["chinchilla"] = " #9b927b";

    
    
    window.colorMap["oatmeal"] = "#ccc4b4";

    
    
    window.colorMap["brook green"] = "#a8decc";

    
    
    window.colorMap["sesame"] = "#bfa68f";

    
    
    window.colorMap["lichen blue"] = "#638db7";

    
    
    window.colorMap["eclipse"] = "#3b3a50";

    
    
    window.colorMap["lavender lustre"] = "#8b9cc0";

    
    
    window.colorMap["chocolate truffle"] = " #8c4559";

    
    
    window.colorMap["duck green"] = "#5a6f65";

    
    
    window.colorMap["charcoal gray"] = "#6e6e6d";

    
    
    window.colorMap["storm front"] = "#7c787c";

    
    
    window.colorMap["blue fog"] = "#97abbd";

    
    
    window.colorMap["heather gray"] = "#5f5e62";

    
    
    window.colorMap["boulder"] = "#d1be9a";

    
    
    window.colorMap["dark gray"] = "#6d7073";

    
    
    window.colorMap["dark blue"] = "#3b4853";

    
    
    window.colorMap["subtle green"] = "#b5cbbb";

    
    
    window.colorMap["shadow lime"] = "#d3e09c";

    
    
    window.colorMap["nautcal blue"] = "#315592";

    
    
    window.colorMap["odyssey gray"] = "#4f4f5c";

    
    
    window.colorMap["pussywillow gray"] = "#aeafa4";

    
    
    window.colorMap["blossom"] = "#f2b5b0";

    
    
    window.colorMap["light blue"] = "#809ca7";

    
    
    window.colorMap["moss green"] = "#9b9b5b";

    
    
    window.colorMap["caramel cafe"] = "#8b5a3d";

    
    
    window.colorMap["salute"] = "#3b3f49";

    
    
    window.colorMap["lunar rock"] = "#c7c8ca";

    
    
    window.colorMap["jet black"] = "#3e4043";

    
    
    window.colorMap["dry rose"] = "#925266";

    
    
    window.colorMap["mood indigo"] = "#434a59";

    
    
    window.colorMap["alloy"] = "#98979a";

    
    
    window.colorMap["navy peony"] = "#394868";

    
    
    window.colorMap["slate gray"] = "#8a9792";

    
    
    window.colorMap["baton rouge"] = "#9a3f6f";

    
    
    window.colorMap["rose red"] = "#c3375c";

    
    
    window.colorMap["heron"] = "#686884";

    
    
    window.colorMap["prune"] = "#654856";

    
    
    window.colorMap["grape royale"] = "#5b4161";

    
    
    window.colorMap["burnt olive"] = "#706e5c";

    
    
    window.colorMap["puce"] = "#584747";

    
    
    window.colorMap["amberglow"] = "#e17f47";

    
    
    window.colorMap["merlot"] = "#7a393e";

    
    
    window.colorMap["dark purple"] = "#6d3e5b";

    
    
    window.colorMap["duffel bag"] = "#464c46";

    
    
    window.colorMap["ocean cavern"] = "#3a3f59";

    
    
    window.colorMap["dark shadow"] = "#505557";

    
    
    window.colorMap["infinity"] = "#6b7d98";

    
    
    window.colorMap["mauve shadows"] = "#b59ba6";

    
    
    window.colorMap["pansy"] = "#6e4c82";

    
    
    window.colorMap["blue atoll"] = "#00b5d7";

    
    
    window.colorMap["deep lavender"] = "#7a5999";

    
    
    window.colorMap["ensign blue"] = "#45566f";

    
    
    window.colorMap["bachelor button"] = "#4cb9d6";

    
    
    window.colorMap["corsair"] = "#2d5f74";

    
    
    window.colorMap["olive green"] = "#80856d";

    
    
    window.colorMap["bluish violet"] = "#365176";

    
    
    window.colorMap["pale green"] = "#b7be9a";

    
    
    window.colorMap["spring bud"] = "#70d4a5";

    
    
    window.colorMap["tomato"] = "#ce3845";

    
    
    window.colorMap["beach glass"] = "#97dfce";

    
    
    window.colorMap["vibrant orange"] = "#ff7338";

    
    
    window.colorMap["custard"] = " #e8d88d";

    
    
    window.colorMap["teal"] = "#276a6c";

    
    
    window.colorMap["gargoyle"] = "#6a6c6b";

    
    
    window.colorMap["red alert"] = "#d34038";

    
    
    window.colorMap["princess blue"] = "#2e5d9f";

    
    
    window.colorMap["illuminating"] = "#f3e04e";

    
    
    window.colorMap["bonnie blue"] = "#59a0d1";

    
    
    window.colorMap["blue curacao"] = "#36bac6";

    
    
    window.colorMap["marigold"] = "#feae51";

    
    
    window.colorMap["vermillion orange"] = "#fb683f";

    
    
    window.colorMap["tidal foam"] = "#c4bca4";

    
    
    window.colorMap["loden frost"] = "#7e9982";

    
    
    window.colorMap["stellar"] = "#46647d";

    
    
    window.colorMap["burnished lilac"] = "#c3adb3";

    
    
    window.colorMap["dark olive"] = "#504c2e";

    
    
    window.colorMap["steel blue"] = "#2d5f74";

    
    
    window.colorMap["strawberry cream"] = "#f4c3c4";

    
    
    window.colorMap["navy heather"] = " #4d6080";

    
    
    window.colorMap["meadow mist"] = "#d4ddc4";

    
    
    window.colorMap["morocco blue"] = "#215866";

    
    
    window.colorMap["desert mist"] = "#e0b588";

    
    
    window.colorMap["jade green"] = "#79b998";

    
    
    window.colorMap["quartz blue"] = "#274374";

    
    
    window.colorMap["fluorescent yellow"] = "#83f52c";

    
    
    window.colorMap["black flowers"] = "multi-icon.jpg";

    
    
    window.colorMap["pink white flowers"] = "multi-icon.jpg";

    
    
    window.colorMap["black white flowers"] = "multi-icon.jpg";

    
    
    window.colorMap["gray"] = "#b0b2b5";

    
    
    window.colorMap["printed green flower"] = "multi-icon.jpg";

    
    
    window.colorMap["printed gray leaf"] = "multi-icon.jpg";

    
    
    window.colorMap["heather green"] = "#708059";

    
    
    window.colorMap["grey"] = "#b0b2b5";

    
    
    window.colorMap["wine red"] = "#663f45";

    
    
    window.colorMap["light gray"] = "#b0b2b5";

    
    
    window.colorMap["navy"] = "#3b3a50";

    
    
    window.colorMap["taro purple"] = "#A3A6E8";

    
    
    window.colorMap["pink"] = "#ffc0cb";

    
    
    window.colorMap["red wine"] = "#663f45";

    
    
    window.colorMap["paisley purple"] = "#47203B";

    
    
    window.colorMap["light pink"] = "#ffd9e6";

    
    
    window.colorMap["steel gray"] = "#6D7073";

    
    
    window.colorMap["deep gray"] = "#5F5E62";

    
    
    window.colorMap["pond"] = "#9DCFD8";

    
    
    window.colorMap["light green"] = "#63674c";

    
    
    window.colorMap["suntan"] = "#AE9F82";

    
    
    window.colorMap["army green"] = "#60614C";

    
    
    window.colorMap["purple"] = "#A54DCF";

    
    
    window.colorMap["royal blue"] = "#2c4697";

    
    
    window.colorMap["rouge red"] = "#680407";

    
    
    window.colorMap["sage"] = "#8A9A5B";

    
    
    window.colorMap["ocean blue"] = "#4f42b5";

    
    
    window.colorMap["dark red"] = "#793735";

    
    
    window.colorMap["raw khaki"] = "#7e9b76";

    
    
    window.colorMap["khaki"] = "#E8D7B6";

    
    
    window.colorMap["emerald"] = "#0b480d";

    
    
    window.colorMap["slate green"] = "#616340";

    
    
    window.colorMap["forest green"] = "#5fa777";

    
    
    window.colorMap["blackish green"] = "#174036";

    
    
    window.colorMap["silver"] = "#aaacb2";

    
    
    window.colorMap["aqua"] = "#9cceb7";

    
    
    window.colorMap["gray/white"] = "#3d3f43";

    
    
    window.colorMap["spray green"] = "#98b496";

    
    
    window.colorMap["sky blue"] = "#4983ab";

    
    
    window.colorMap["coral red"] = "#781f17";

    
    
    window.colorMap["coffee"] = "#4a2c2a";

    
    
    window.colorMap["purple heather"] = "#4b0080";

    
    
    window.colorMap["misted yellow"] = "#d9b965";

    
    
    window.colorMap["coral"] = "#d04c60";

    
    
    window.colorMap["light wine red"] = "#793231";

    
    
    window.colorMap["maroon"] = "#421d1e";

    
    
    window.colorMap["mint green"] = "#cfffe5";

    
    
    window.colorMap["navy blue"] = "#14152b";

    
    
    window.colorMap["heather coral"] = "#e0a7af";

    
    
    window.colorMap["wine"] = "#663f45";

    
    
    window.colorMap["peach whip"] = "#dbbeb7";

    
    
    window.colorMap["dark grey"] = "#525055";

    
    
    window.colorMap["burgundy red"] = "#742c42";

    
    
    window.colorMap["violet rose"] = "#c0428a";

    
    
    window.colorMap["sage green"] = "#8A9A5B";

    
    
    window.colorMap["blue"] = "#49527a";

    
    
    window.colorMap["niagara"] = "#5686a5";

    
    
    window.colorMap["charcoal"] = "#4d4c4f";

    
    
    window.colorMap["rosy"] = "#d22e2e";

    
    
    window.colorMap["red"] = "#d22e2e";

    
    
    window.colorMap["ruby wine"] = "#541c24";

    
    
    window.colorMap["magenta"] = "#421f3e";

    
    
    window.colorMap["orange"] = "#ff8800";

    
    
    window.colorMap["blue magenta"] = "#401b54";

    
    
    window.colorMap["imperial"] = "#6a356a";

    
    
    window.colorMap["deep blue"] = "#0d468c";

    
    
    window.colorMap["gray heather"] = "#575a56";

    
    
    window.colorMap["seashell pink"] = "#d4c8c6";

    
    
    window.colorMap["caramel café"] = "#845433";

    
    
    window.colorMap["bumblebee"] = "#F0B903";

    
    
    window.colorMap["dark brown"] = "#5d464c";

    
    
    window.colorMap["yellow"] = "#d1821b";

    
    
    window.colorMap["black"] = "#232227";

    
    
    window.colorMap["black/orange"] = "#ff8800";

    
    
    window.colorMap["dark gray/black"] = "#6d7073";

    
    
    window.colorMap["black/pink"] = "#ffc0cb";

    
    
    window.colorMap["black/purple"] = "#A54DCF";

    
    
    window.colorMap["black/blue"] = "#0f438a";

    
    
    window.colorMap["white"] = "#ffffff";

    
    
    window.colorMap["heather blue"] = "#262e40";

    
    
    window.colorMap["heather purple"] = "#4b0080";

    
    
    window.colorMap["copen blue"] = "#3d7198";

    
    
    window.colorMap["cement gray"] = "#6f777e";

    
    
    window.colorMap["brown"] = "#a55829";

    
    
    window.colorMap["aqua blue"] = "#0a95cd";

    
    
    window.colorMap["blue/white"] = "#323241";

    
    
    window.colorMap["lavender gray"] = "#616a6c";

    
    
    window.colorMap["green"] = "#275b4f";

    
    
    window.colorMap["dark green"] = "#12615f";

    
    
    window.colorMap["heather army green"] = "#61755e";

    
    
    window.colorMap["fluorescent green"] = "#abdc2d";

    
    
    window.colorMap["coffee gray"] = "#37383c";

    
    
    window.colorMap["print 2"] = "#2d2a3e";

    
    
    window.colorMap["print 3"] = "#81bdea";

    
    
    window.colorMap["print 1"] = "#666a7a";

    
    
    window.colorMap["emerald green"] = "#cccda2";

    
    
    window.colorMap["coral blue"] = "#0393a3";

    
    
    window.colorMap["bright orange"] = "#ec7e3f";

    
    
    window.colorMap["powder blue"] = "#77a6d2";

    
    
    window.colorMap["light purple"] = "#b8b0e2";

    
    
    window.colorMap["snow blue"] = "#b0c4e5";

    
    
    window.colorMap["bright blue"] = "#4760b2";

    
    
    window.colorMap["heather light gray"] = "#bfbfbf";

    
    
    window.colorMap["heather orange"] = "#fedec5";

    
    
    window.colorMap["light brown"] = "#cbc9bc";

    
    
    window.colorMap["print 1"] = "#343535";

    
    
    window.colorMap["print 2"] = "#d5ccd1";

    
    
    window.colorMap["print 3"] = "#4a4950";

    
    
    window.colorMap["print 4"] = "#252e41";

    
    
    window.colorMap["print 5"] = "#33383b";

    
    
    window.colorMap["rouge pink"] = "#b64562";

    
    
    window.colorMap["heather light blue"] = "#69989d";

    
    
    window.colorMap["heather black"] = "#252525";

    
    
    window.colorMap["heather khaki"] = "#d4ccc9";

    
    
    window.colorMap["heather dark green"] = "#5b898a";

    
    
    window.colorMap["peach"] = "#8d5e62";

    
    
    window.colorMap["cyan green"] = "#98cccc";

    
    
    window.colorMap["peacock blue"] = "#1e4c63";

    
    
    window.colorMap["coastal blue"] = "#389cb4";

    
    
    window.colorMap["caramel brown"] = "#835641";

    
    
    window.colorMap["blush pink"] = "#c26093";

    
    
    window.colorMap["lightning green"] = "#456a7d";

    
    
    window.colorMap["light sand green"] = "#c7c1ab";

    
    
    window.colorMap["heather dark gray"] = "#374046";

    
    
    window.colorMap["cocoa brown"] = "#967862";

    
    
    window.colorMap["blue/white"] = "#3a436c";

    
    
    window.colorMap["strait blue"] = "#1a385d";

    
    
    window.colorMap["teak brown"] = "#c5bca5";

    
    
    window.colorMap["tricolor leaf"] = "#3d352f";

    
    
    window.colorMap["purple rose"] = "#c2aedc";

    
    
    window.colorMap["gardenia"] = "#d4cab4";

    
    
    window.colorMap["pea green"] = "#cbd5d2";

    
    
    window.colorMap["montana purple"] = "#6e6272";

    
    
    window.colorMap["dark army green"] = "#505d50";

    
    
    window.colorMap["deep sea blue"] = "#345163";

    
    
    window.colorMap["garnet red"] = "#ff4a35";

    
    
    window.colorMap["mint green"] = "#d0edee";

    
    
    window.colorMap["haze blue"] = "#8898b2";

    
    
    window.colorMap["sea blue"] = "#757b95";

    
    
    window.colorMap["ice gray"] = "#d0d0d0";

    
    
    window.colorMap["tea brown"] = "#c1a686";

    
    
    window.colorMap["cobalt blue"] = "#285489";

    
    
    window.colorMap["elephant grey"] = "#c9cbcb";

    
    
    window.colorMap["wax gray"] = "#50514c";

    
    
    window.colorMap["light grey"] = "#b4b8bb";

    
    
    window.colorMap["reef green"] = "#484f3f";

    
    
    window.colorMap["light gray"] = "#D5D6D7";

    
    
    window.colorMap["brown"] = "#9A5630";

    
    
    window.colorMap["dark purple"] = "#A69CAB";

    
    
    window.colorMap["blue"] = "#49527a";

    
    
    window.colorMap["redwood"] = "#A86148";

    
    
    window.colorMap["earth brown"] = "#A08154";

    
    
    window.colorMap["dark brown"] = "#715257ff";

    
    
    window.colorMap["burgundy"] = "#693a40ff";

    
    
    window.colorMap["sandy green"] = "#b5ae9bff";

    
    
    window.colorMap["red coral"] = "#f59f90";

    
    
    window.colorMap["sunset purple"] = "#887497";



window.globalColorPaterns = `Multi::multi-icon.jpg
Hot Pink::#e86288
Weathered Teak::#9f9283
Smoked Pearl::#6a6c6e
Star White::#ecece7
Anthracite::#3d3f43
Violet Tulip::#9c90c4
Barrier Reef::#0088a5
Peacoat::#3f3f50
Peacock::#3f3f50
Rifle Green::#515848
Doeskin::#bdad9a
Estate Blue::#3a4462
Glacier Gray::#c5c9ca
Shadow Purple::#573e54
Gibraltar Sea::#30475e
Seal Brown::#4b4140
Tannin::#a68b6f
Frost Gray::#848587
Ebony::#494d53
Lucent White::#f3f4f5
Pink Dogwood::#f5d3d4
Botanical Garden::#30524e
Elephant Gray::#a9b1b3
Dark Sapphire::#3a3d49
Silver Sconce::#9e9ea3
Montana Grape::#6e6276
Zinfandel::#663f45
Winsome Orchid::#d4b9cb
Kentucky Blue::#a0b0d1
Limestone::#9c9f9c
Plumeria::#f891a3
Very Grape::#b994b2
Cocoa Crème::#8b7360
Lava Falls::#9f383a
Winter Moss::#60614c
Ethereal Blue::#61a9d2
Burnt Coral::#e9897e
Cactus Flower::#ac4977
Teal Green::#276a6c
Antique Green::#3b6d69
Spa Retreat::#b6e7ec
Fiery Red::#d2393e 
Blue Wing Teal::#384b60
Pastel Blue::#bdd6d9
Plum Kitten::#615e60
Hawthorn Rose::#d189af
Twill::#a89f84
Ashleigh Blue::#6f8aad
Rose Dawn::#c2877b
Stone Blue::#809ca7
Harbor Mist::#b0b2b5
Deep Sea::#53817b
Bijou Blue:: #4d6080
Pirate Black::#373838
Castlerock::#5f5e62
Chinchilla:: #9b927b
Oatmeal::#ccc4b4
Brook Green::#a8decc
Sesame::#bfa68f
Lichen Blue::#638db7
Eclipse::#3b3a50
Lavender Lustre::#8b9cc0
Chocolate Truffle:: #8c4559
Duck Green::#5a6f65
Charcoal Gray::#6e6e6d
Storm Front::#7c787c
Blue Fog::#97abbd
Heather Gray::#5f5e62
Boulder::#d1be9a
Dark Gray::#6d7073
Dark Blue::#3b4853
Subtle Green::#b5cbbb
Shadow Lime::#d3e09c
Nautcal Blue::#315592
Odyssey Gray::#4f4f5c
Pussywillow Gray::#aeafa4
Blossom::#f2b5b0
Light Blue::#809ca7
Moss Green::#9b9b5b
Caramel Cafe::#8b5a3d
Salute::#3b3f49
Lunar Rock::#c7c8ca
Jet Black::#3e4043
Dry Rose::#925266
Mood Indigo::#434a59
Alloy::#98979a
Navy Peony::#394868
Slate Gray::#8a9792
Baton Rouge::#9a3f6f
Rose Red::#c3375c
Heron::#686884
Prune::#654856
Grape Royale::#5b4161
Burnt Olive::#706e5c
Puce::#584747
Amberglow::#e17f47
Merlot::#7a393e
Dark Purple::#6d3e5b
Duffel Bag::#464c46
Ocean Cavern::#3a3f59
Dark Shadow::#505557
Infinity::#6b7d98
Mauve Shadows::#b59ba6
Pansy::#6e4c82
Blue Atoll::#00b5d7
Deep Lavender::#7a5999
Ensign Blue::#45566f
Bachelor Button::#4cb9d6
Corsair::#2d5f74
Olive Green::#80856d
Bluish Violet::#365176
Pale Green::#b7be9a
Spring Bud::#70d4a5
Tomato::#ce3845
Beach Glass::#97dfce
Vibrant Orange::#ff7338
Custard:: #e8d88d
Teal::#276a6c
Gargoyle::#6a6c6b
Red Alert::#d34038
Princess Blue::#2e5d9f
Illuminating::#f3e04e
Bonnie Blue::#59a0d1
Blue Curacao::#36bac6
Marigold::#feae51
Vermillion Orange::#fb683f
Tidal Foam::#c4bca4
Loden Frost::#7e9982
Stellar::#46647d
Burnished Lilac::#c3adb3
Dark Olive::#504c2e
Steel Blue::#2d5f74
Strawberry Cream::#f4c3c4
Navy Heather:: #4d6080
Meadow Mist::#d4ddc4
Morocco Blue::#215866
Desert Mist::#e0b588
Jade green::#79b998
Quartz blue::#274374
Fluorescent Yellow::#83f52c
Black Flowers::multi-icon.jpg
Pink White Flowers::multi-icon.jpg
Black White Flowers::multi-icon.jpg
Gray::#b0b2b5
Printed Green Flower::multi-icon.jpg
Printed Gray Leaf::multi-icon.jpg
Heather Green::#708059
Grey::#b0b2b5
Wine Red::#663f45
Light Gray::#b0b2b5
Navy::#3b3a50
Taro Purple::#A3A6E8
Pink::#ffc0cb
Red Wine::#663f45
Paisley Purple::#47203B
Light Pink::#ffd9e6
Steel Gray::#6D7073
Deep Gray::#5F5E62
Pond::#9DCFD8
Light Green::#63674c
Suntan::#AE9F82
Army Green::#60614C
Purple::#A54DCF
Royal Blue::#2c4697
Rouge Red::#680407
Sage::#8A9A5B
Ocean Blue::#4f42b5
Dark Red::#793735
Raw Khaki::#7e9b76
Khaki::#E8D7B6
Emerald::#0b480d
Slate Green::#616340
Forest Green::#5fa777
Blackish Green::#174036
Silver::#aaacb2
Aqua::#9cceb7
Gray/White::#3d3f43
Spray Green::#98b496
Sky Blue::#4983ab
Coral Red::#781f17
Coffee::#4a2c2a
Purple Heather::#4b0080
Misted Yellow::#d9b965
Coral::#d04c60
Light Wine Red::#793231
Maroon::#421d1e
Mint Green::#cfffe5
Navy Blue::#14152b
Heather Coral::#e0a7af
Wine::#663f45
Peach Whip::#dbbeb7
Dark Grey::#525055
Burgundy Red::#742c42
Violet Rose::#c0428a
Sage Green::#8A9A5B
Blue::#49527a
Niagara::#5686a5
Charcoal::#4d4c4f
Rosy::#d22e2e
Red::#d22e2e
Ruby Wine::#541c24
Magenta::#421f3e
Orange::#ff8800
Blue Magenta::#401b54
Imperial::#6a356a
Deep Blue::#0d468c
Gray Heather::#575a56
Seashell Pink::#d4c8c6
Caramel Café::#845433
Bumblebee::#F0B903
Dark Brown::#5d464c
Yellow::#d1821b
Black::#232227
Black/Orange::#ff8800
Dark Gray/Black::#6d7073
Black/Pink::#ffc0cb
Black/Purple::#A54DCF
Black/Blue::#0f438a
White::#ffffff
Heather Blue::#262e40
Heather Purple::#4b0080
Copen Blue::#3d7198
Cement Gray::#6f777e
Brown::#a55829
Aqua Blue::#0a95cd
Blue/White::#323241
Lavender Gray::#616a6c
Green::#275b4f
Dark Green::#12615f
Heather Army Green::#61755e
Fluorescent Green::#abdc2d
Coffee Gray::#37383c
Print 2::#2d2a3e
Print 3::#81bdea
Print 1::#666a7a
Emerald Green::#cccda2
Coral Blue::#0393a3
Bright Orange::#ec7e3f
Powder Blue::#77a6d2
Light Purple::#b8b0e2
Snow Blue::#b0c4e5
Bright Blue::#4760b2
Heather Light Gray::#bfbfbf
Heather Orange::#fedec5
Light Brown::#cbc9bc
Print 1::#343535
Print 2::#d5ccd1
Print 3::#4a4950
Print 4::#252e41
Print 5::#33383b
Rouge Pink::#b64562
Heather Light Blue::#69989d
Heather Black::#252525
Heather Khaki::#d4ccc9
Heather Dark Green::#5b898a
Peach::#8d5e62
Cyan Green::#98cccc
Peacock Blue::#1e4c63
Coastal Blue::#389cb4
Caramel Brown::#835641
Blush Pink::#c26093
Lightning Green::#456a7d
Light Sand Green::#c7c1ab
Heather Dark Gray::#374046
Cocoa Brown::#967862
Blue/White::#3a436c
Strait Blue::#1a385d
Teak Brown::#c5bca5
Tricolor Leaf::#3d352f
Purple Rose::#c2aedc
Gardenia::#d4cab4
Pea Green::#cbd5d2
Montana Purple::#6e6272
Dark Army Green::#505d50
Deep Sea Blue::#345163
Garnet Red::#ff4a35
Mint Green::#d0edee
Haze Blue::#8898b2
Sea Blue::#757b95
Ice Gray::#d0d0d0
Tea Brown::#c1a686
Cobalt Blue::#285489
Elephant Grey::#c9cbcb
Wax Gray::#50514c
Light Grey::#b4b8bb
Reef Green::#484f3f
Light Gray::#D5D6D7
Brown::#9A5630
Dark Purple::#A69CAB
Blue::#49527a
Redwood::#A86148
Earth Brown::#A08154
Dark Brown::#715257ff
Burgundy::#693a40ff
Sandy Green::#b5ae9bff
Red Coral::#f59f90
Sunset Purple::#887497`;
